import { UserInfoResultAjax } from './user-info.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    userInfo: UserInfoResultAjax;
  }
}

export const userInfoBackend = {
  fetch: () => ({
    endpoint: `navigation/user-info.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-info/user-info.backend.ts